export default "__VITE_ASSET__4bfdea57__"